import useSWR from 'swr';
import DashboardRegisterDefaultPicture from '@quickService/DashboardRegisterDefaultPicture';

export default function useDefaultImage() {
  const { data } = useSWR(
    {
      event_id: '',
    },
    DashboardRegisterDefaultPicture,
    {
      revalidateOnFocus: false,
    },
  );

  if (data?.code === 0) {
    return data.data?.default_picture;
  }
  return {
    cos_key: '',
    cos_url: '',
  };
}
